import {Suspense, useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'
import {ThemeModeProvider} from '../_metronic/partials'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {ConfirmDialogHost} from './tfi/components/ConfirmDialogHost'
import {toAbsoluteUrl} from '../_metronic/helpers'
import {useGetUser} from './tfi/store/userStore'
import {STORAGE_NAMES} from './tfi/helpers/consts'
import {WebSocketProvider} from './tfi/providers/WebSocketProvider'

import 'react-quill/dist/quill.snow.css'

const shouldTrackRoute = (pathname: string) => {
  if (pathname === '/login' || pathname === '/logout') return false
  if (pathname === '/dashboard' || pathname === '/dashboard/lead') return false
  if (pathname.startsWith('/error')) return false
  return true
}

const RouteTracker = () => {
  const location = useLocation()
  const user = useGetUser((s) => s.user)

  useEffect(() => {
    if (!user) return
    if (!shouldTrackRoute(location.pathname)) return

    const path = `${location.pathname}${location.search}`
    window.localStorage.setItem(STORAGE_NAMES.LAST_ROUTE, path)
  }, [location.pathname, location.search, user])

  return null
}

const App = () => {
  return (
    <Suspense
      fallback={
        <div
          className='d-flex align-items-center justify-content-center bg-dark'
          style={{width: '100vw', height: '100vh'}}
        >
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/tfi/logoN.jpg')}
            className='h-75px tfi-blink-logo'
          />
        </div>
      }
    >
      <ToastContainer />
      <I18nProvider>
        <ConfirmDialogHost />
        <LayoutProvider>
          <ThemeModeProvider>
            <AuthInit>
              <WebSocketProvider>
                <RouteTracker />
                <Outlet />
                <MasterInit />
              </WebSocketProvider>
            </AuthInit>
          </ThemeModeProvider>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
